import { JobModel } from '@/model/job';

export const job7th: JobModel[] = [
  {
    label: 'アスリート',
    skill: {
      required: ['近接戦闘[格闘]', '乗馬', '水泳', '跳躍', '投擲', '登攀'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から2つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 70,
      min: 9,
    },
    pointFormula: [1, 2],
  },
  {
    label: '医師',
    skill: {
      required: ['医学', '応急手当', '科学[生物学]', '科学[薬学]', '心理学', 'ほかの言語'],
      selectables: [
        {
          description: '研究もしくは個人的な専門として任意の他の2つの技能',
          skills: [],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 80,
      min: 30,
    },
    pointFormula: [0],
  },
  {
    label: 'エンジニア',
    skill: {
      required: ['科学[工学]', '科学[物理学]', '機械修理', '芸術/製作', '重機械操作', '電気修理', '図書館'],
      selectables: [
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 60,
      min: 30,
    },
    pointFormula: [0],
  },
  {
    label: 'エンターテイナー',
    skill: {
      required: ['聞き耳', '芸術/製作', '心理学', '変装'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から2つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 2,
        },
        {
          description: '任意のほかの2つの技能',
          skills: [],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 70,
      min: 9,
    },
    pointFormula: [4],
  },
  {
    label: '活動家',
    skill: {
      required: ['隠密', '心理学', '歴史'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から2つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 2,
        },
        {
          description: '任意のほかの3つの技能',
          skills: [],
          count: 3,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 0,
    },
    pointFormula: [3, 4],
  },
  {
    label: '教授',
    skill: {
      required: ['心理学', '図書館', 'ほかの言語', '母国語'],
      selectables: [
        {
          description: '研究または個人的な専門として任意の4つの技能',
          skills: [],
          count: 4,
        },
      ],
    },
    confidence: {
      max: 70,
      min: 20,
    },
    pointFormula: [0],
  },
  {
    label: '警官',
    skill: {
      required: ['応急手当', '近接戦闘[格闘]', '射撃[拳銃]', '心理学', '法律', '目星'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '個人的な専門として運転（自動車）または乗馬のどちらか1つ',
          skills: ['運転', '乗馬'],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 9,
    },
    pointFormula: [1, 2],
  },
  {
    label: '刑事',
    skill: {
      required: ['聞き耳', '射撃[拳銃]', '心理学', '法律', '目星'],
      selectables: [
        {
          description: '芸術/製作または変装',
          skills: ['芸術/製作', '変装'],
          count: 1,
        },
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 50,
      min: 20,
    },
    pointFormula: [1, 2],
  },
  {
    label: '芸術家',
    skill: {
      required: ['芸術/製作', '心理学', '目星', 'ほかの言語'],
      selectables: [
        {
          description: '自然もしくは歴史',
          skills: ['自然', '歴史'],
          count: 1,
        },
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの2つの技能',
          skills: [],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 50,
      min: 9,
    },
    pointFormula: [1, 3],
  },
  {
    label: '古物研究家',
    skill: {
      required: ['鑑定', '芸術/製作', '図書館', '目星', '歴史', 'ほかの言語'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 70,
      min: 30,
    },
    pointFormula: [0],
  },
  {
    label: '作家',
    skill: {
      required: ['芸術/製作', '心理学', '図書館', '歴史', '母国語', 'ほかの言語'],
      selectables: [
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 9,
    },
    pointFormula: [0],
  },
  {
    label: '士官',
    skill: {
      required: ['経理', 'サバイバル', '射撃[拳銃]', '心理学', 'ナビゲート'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から2つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 2,
        },
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 70,
      min: 20,
    },
    pointFormula: [1, 2],
  },
  {
    label: '司書',
    skill: {
      required: ['経理', '図書館', 'ほかの言語', '母国語'],
      selectables: [
        {
          description: '個人的な専門または記事を読む専門家として任意のほかの4つの技能',
          skills: [],
          count: 4,
        },
      ],
    },
    confidence: {
      max: 35,
      min: 9,
    },
    pointFormula: [0],
  },
  {
    label: 'ジャーナリスト',
    skill: {
      required: ['芸術/製作', '心理学', '図書館', '歴史', '母国語'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの2つの技能',
          skills: [],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 9,
    },
    pointFormula: [0],
  },
  {
    label: '私立探偵',
    skill: {
      required: ['芸術/製作', '心理学', '図書館', '変装', '法律', '目星'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 9,
    },
    pointFormula: [1, 2],
  },
  {
    label: '聖職者',
    skill: {
      required: ['聞き耳', '経理', '心理学', '図書館', '歴史', 'ほかの言語'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 60,
      min: 9,
    },
    pointFormula: [0],
  },
  {
    label: '超心理学者',
    skill: {
      required: ['オカルト', '芸術/製作', '心理学', '人類学', '図書館', '歴史', 'ほかの言語'],
      selectables: [
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 9,
    },
    pointFormula: [0],
  },
  {
    label: 'ディレッタント',
    skill: {
      required: ['芸術/製作', '射撃[拳銃]', '乗馬', 'ほかの言語'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの3つの技能',
          skills: [],
          count: 3,
        },
      ],
    },
    confidence: {
      max: 99,
      min: 50,
    },
    pointFormula: [4],
  },
  {
    label: '伝道者',
    skill: {
      required: ['医学', '応急手当', '機械修理', '芸術/製作', '自然'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの2つの技能',
          skills: [],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 0,
    },
    pointFormula: [0],
  },
  {
    label: 'トライブ・メンバー',
    skill: {
      required: ['オカルト', '聞き耳', 'サバイバル', '自然', '水泳', '登攀', '目星'],
      selectables: [
        {
          description: '近接戦闘または投擲',
          skills: ['近接戦闘[格闘]', '投擲'],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 15,
      min: 0,
    },
    pointFormula: [1, 2],
  },
  {
    label: '農夫',
    skill: {
      required: ['運転', '機械修理', '芸術/製作', '自然', '重機械操作', '追跡'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの1つの技能',
          skills: [],
          count: 1,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 9,
    },
    pointFormula: [1, 2],
  },
  {
    label: 'パイロット',
    skill: {
      required: ['科学[天文学]', '機械修理', '重機械操作', '操縦', '電気修理', 'ナビゲート'],
      selectables: [
        {
          description: '任意のほかの2つの技能',
          skills: [],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 70,
      min: 20,
    },
    pointFormula: [1],
  },
  {
    label: 'ハッカー',
    skill: {
      required: ['コンピューター', '電気修理', '電子工学', '図書館', '目星'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの2つの技能',
          skills: [],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 70,
      min: 10,
    },
    pointFormula: [0],
  },
  {
    label: '犯罪者',
    skill: {
      required: ['隠密', '心理学', '目星'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '以下から専門の技能4つ',
          skills: ['鍵開け', '鑑定', '機械修理', '近接戦闘[格闘]', '射撃[拳銃]', '手さばき', '変装'],
          count: 4,
        },
      ],
    },
    confidence: {
      max: 65,
      min: 5,
    },
    pointFormula: [1, 2],
  },
  {
    label: '兵士',
    skill: {
      required: ['隠密', '回避', '近接戦闘[格闘]', 'サバイバル', '射撃[拳銃]'],
      selectables: [
        {
          description: '水泳または登攀',
          skills: ['水泳', '登攀'],
          count: 1,
        },
        {
          description: '以下から2つの技能',
          skills: ['応急手当', '機械修理', 'ほかの言語'],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 9,
    },
    pointFormula: [1, 2],
  },
  {
    label: '法律家',
    skill: {
      required: ['経理', '心理学', '図書館', '法律'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から2つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 2,
        },
        {
          description: '任意のほかの2つの技能',
          skills: [],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 80,
      min: 30,
    },
    pointFormula: [0],
  },
  {
    label: '放浪者',
    skill: {
      required: ['隠密', '聞き耳', '跳躍', '登攀', 'ナビゲート'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの2つの技能',
          skills: [],
          count: 2,
        },
      ],
    },
    confidence: {
      max: 5,
      min: 0,
    },
    pointFormula: [1, 2, 4],
  },
  {
    label: 'ミュージシャン',
    skill: {
      required: ['聞き耳', '芸術/製作', '心理学'],
      selectables: [
        {
          description: '対人関係技能（威圧、言いくるめ、説得、魅惑）から1つ',
          skills: ['威圧', '言いくるめ', '説得', '魅惑'],
          count: 1,
        },
        {
          description: '任意のほかの4つの技能',
          skills: [],
          count: 4,
        },
      ],
    },
    confidence: {
      max: 30,
      min: 9,
    },
    pointFormula: [1, 3],
  },
];
